import React from 'react';
import { CTAButton } from '../CTAButton';
import { methodSteps } from '../../data/landing';
export function Method() {
  return <section className="bg-white" data-id="element-239" data-mp="2fgivb56nrr8a">
      <div className="mx-auto max-w-3xl px-5 py-14 md:py-20" data-id="element-240" data-mp="2fibtdw37h34o">
        <div className="rounded-3xl bg-navy px-6 py-10 text-center sm:px-10" data-id="element-241" data-mp="2anpombrmq8tk">
          <p className="text-base font-extrabold uppercase tracking-wide text-white/70" data-id="element-242" data-mp="26mmbhx0yuqw1">The problem isn't that you don't care enough.</p>
          <h2 className="mt-4 font-display text-[30px] font-bold leading-tight text-white sm:text-[42px]" data-id="element-243" data-mp="21mhrhx0une12">
            You don't need more information. <em className="text-sun" data-id="element-244" data-mp="1rpv719cfqozk">You need a simple way to use the information you already have.</em>
          </h2>
        </div>

        <p className="mt-10 text-center text-lg leading-relaxed text-muted" data-id="element-245" data-mp="1nq4k5gq14t0b">
          I took the ideas, observations and practical strategies that parents often have scattered across books, posts, videos and notes… and organized them into{' '}
          <strong className="text-navy" data-id="element-246" data-mp="37in77y3899sz">one simple response framework:</strong>
        </p>

        <ol className="relative mt-10 space-y-4" data-id="element-247" data-mp="37kzxcyj52qh4">
          <span className="absolute bottom-8 left-7 top-8 w-0.5 bg-navy/10" aria-hidden="true" data-id="element-248" data-mp="3cirnbn0842io" />
          {methodSteps.map((step, i) => {
          const Icon = step.icon;
          return <li key={step.name} className="relative flex gap-4" data-id="element-249" data-mp="32klsfpcu3wnb" data-mpi={i}>
                <span className={`relative z-10 grid h-14 w-14 shrink-0 place-items-center rounded-full text-white shadow-md ${step.circle}`} data-id="element-250" data-mp="3q9er3tkucilm">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-251" data-mp="3v7pzs0zegn29" />
                </span>
                <div className={`flex-1 rounded-2xl p-5 ${step.soft}`} data-id="element-252" data-mp="3hg1o1yt2c0lt">
                  <p className={`text-sm font-black uppercase tracking-wider ${step.text}`} data-id="element-253" data-mp="3lhwm8ufp5xvd">Step {i + 1}</p>
                  <h3 className="mt-0.5 font-display text-2xl font-bold text-navy" data-id="element-254" data-mp="d2cxa7m271m4">{step.name}</h3>
                  <p className="mt-1.5 text-[17px] leading-relaxed text-navy/80" data-id="element-255" data-mp="htl7v6z4kt0v">{step.detail}</p>
                </div>
              </li>;
        })}
        </ol>

        <div className="mt-10" data-id="element-256" data-mp="nnqcmjg7hlrp">
          <CTAButton label="I want the 5-step system" data-id="element-257" data-mp="norqswsiqodn" />
        </div>
      </div>
    </section>;
}